import MaintainerDashboardView from "../../components/MaintainerDashboardView";

MaintainerDashboardScreen.propTypes = {};

function MaintainerDashboardScreen(props) {
    return (
        <div className="container-fluid px-0">
            <MaintainerDashboardView />
        </div>
    );
}

export default MaintainerDashboardScreen;
